// extracted by mini-css-extract-plugin
module.exports = {"homeContainer":"index-module_homeContainer_2I_zx","taglessContainer":"index-module_taglessContainer_1zvQL"};